import { cx } from '@linaria/core';

import { ButtonBase } from '..';
import type { SizeButtonBaseProps } from '../types';
import { Icon, MainContent, MainContentCaptions, styledButton } from './styles';

export const SizeButtonBase = ({
	size = 'S',
	className,
	children,
	leftIcon,
	rightIcon,
	disabledIconStyles = false,
	width,
	...props
}: SizeButtonBaseProps) => {
	const textSize = size === 'L' ? 'M' : size === 'Badge' ? 'L' : 'S';
	const ContentElement = size === 'Badge' ? MainContentCaptions : MainContent;
	return (
		<ButtonBase
			style={{ width: width ? `${width}px` : undefined }}
			className={cx(styledButton, `size${size}`, className)}
			{...props}
		>
			{leftIcon && (
				<Icon
					as="span"
					size={textSize}
					className={cx(
						'icon-inside-button',
						'left',
						disabledIconStyles && 'disabledIconStyles'
					)}
				>
					{leftIcon}
				</Icon>
			)}
			{children && <ContentElement size={textSize}>{children}</ContentElement>}
			{rightIcon && (
				<Icon
					as="span"
					size={textSize}
					className={cx(
						'icon-inside-button',
						'right',
						disabledIconStyles && 'disabledIconStyles'
					)}
				>
					{rightIcon}
				</Icon>
			)}
		</ButtonBase>
	);
};
